export const isSkipSeniorityBasedOnExperience = (
  yearsOfExperience: number | null | undefined,
): boolean => {
  if (typeof yearsOfExperience !== 'number') {
    return false;
  }
  return yearsOfExperience < 2;
};
